// extracted by mini-css-extract-plugin
export default {"box":"Wallet_box__RAVoW","container":"Wallet_container__avDF0","flex":"Wallet_flex__gszbD"};